import React, {useEffect, useState} from 'react'
import {LayoutChild} from "../../../../palette/Palette";
import HeaderPage from "../../../../palette/HeaderPage";
import './dashboard.css'
import axios from 'axios'
import format from 'date-fns/format'
import {es} from "date-fns/locale";
import {inject, observer} from "mobx-react";
import RouteTrend from "./RouteTrend";
import {LoadIndicator} from 'devextreme-react/load-indicator';
import Actives from "./Actives";
import BookingTrend from "./BookingTrend";
import Payments from "./Payments";
import {Animated} from "react-animated-css";
import Alerts from "../../../../palette/Alerts";

const headers = {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
};

const url = 'https://dashboard-easi4xatjq-uc.a.run.app/dashboard';
//const url = 'http://127.0.0.1:5000/dashboard';

const now = new Date();

const Load = ({textLoad}) => {
    return (
        <div style={{
            width: '100%',
            height: '100vh',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexDirection: 'column'
        }}>
            <LoadIndicator id="medium-indicator" height={40} width={40}/>
            <span style={{fontSize: 11, color: 'gray', marginTop: 5}}>{textLoad}</span>
        </div>
    )
}

function Dashboard(props) {

    const {DataStore} = props;

    const {companyName, idCompany} = DataStore

    const [trigger, setTrigger] = useState(false)
    const [loading, setLoading] = useState(false)
    const [routeTrend, setRouteTrend] = useState(null)
    const [activePassengers, setActivePassengers] = useState(null)
    const [activeDrivers, setActiveDrivers] = useState(null)
    const [status, setStatus] = useState(null)
    const [payments, setPayments] = useState(null)
    const [newPassengers, setNewPassengers] = useState(null)
    const [textLoad, setTextLoad] = useState('Cargando datos')
    const [existData, setExistData] = useState(true)

    const GetDataDashboard = async () => {
        const year = format(now, 'yyyy');
        const month = format(now, 'MMMM', {locale: es});

        const data = {companyName, idCompany, year, month};

        setTimeout(() => setTextLoad('Espere un momento . . .'), 3000)

        await axios.post(url, data, {headers: headers})
            .then(res => {
                if (res.data.exists) {
                    setExistData(true)
                    setRouteTrend(res.data.trips)
                    setStatus(res.data.status)
                    setActiveDrivers(res.data.activeDrivers)
                    setActivePassengers(res.data.activePassengers)
                    setPayments(res.data.payments)
                    setNewPassengers(res.data.newPassengers)
                    setTextLoad('Cargando datos')
                    setLoading(true)

                } else {
                    setExistData(false)
                }
            })
    }

    useEffect(() => {

        let isMounted = true

        if (isMounted) {
            GetDataDashboard().catch((e) => {
                console.log(e)
                setTrigger(!trigger)
            })
        }

        return () => {
            isMounted = false
        }

    }, [trigger])

    return (
        <>
            {(routeTrend && status) ?
                <div style={{background: 'white'}}>
                    <Animated animationIn="fadeIn" animationOut="slideOutUp" isVisible={true}>
                        <div style={{marginTop: 25, width: '100%', position: 'relative', padding: 10}}>

                            <HeaderPage icon={'fas fa-chart-line'} text={'Dashboard'} load={loading}
                                        textLoad={'Cargando....'}/>

                            <div className={'chart-containers'}>
                                <RouteTrend routeTrend={routeTrend}/>
                                <Actives activeDrivers={activeDrivers} activePassengers={activePassengers}
                                         newPassengers={newPassengers}/>
                            </div>
                            <div className={'chart-containers'}>
                                <BookingTrend status={status}/>
                                <Payments payments={payments}/>
                            </div>
                        </div>
                        <div style={{height: 40}}/>

                    </Animated>
                </div> :
                <div>
                    {existData && <Load textLoad={textLoad}/>}
                </div>
            }
            {!existData &&
            <LayoutChild percent={95} margin={'auto'}>
                <Alerts severity={'warning'} body={'Aún no existen datos para mostrar'}/>
            </LayoutChild>
            }
        </>
    )
}

export default inject('DataStore')(observer(Dashboard));
